import { ResponseEntity } from '~client/model/response-entity';
import { rxTask } from '~common/helper/mobx-tasks';
import { apiClient } from '~web/client';

export const deleteResaleListing = rxTask<string, ResponseEntity>((offerGroupId: string) =>
  apiClient.resaleController.deleteResaleListing$(offerGroupId),
);



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/web/src/js/interactor/resale/delete-resale-listing.ts